import type { CalendarDayEvent } from "@/pages/human-resources/time-management/business/calendar/CalendarDayEvent.ts";

export class CalendarDay {
  constructor(
    public readonly date: Date,
    public readonly isClosed: boolean,
    public readonly color: string | undefined,
    public readonly publicHoliday: string | undefined,
    public readonly events: CalendarDayEvent[],
  ) {}

  public totalItems(): number {
    return (this.publicHoliday != undefined ? 1 : 0) + this.events.length;
  }

  public isSpecial(): boolean {
    return this.totalItems() > 0 || this.isClosed;
  }
}
